import Vue from 'vue'
import Router from 'vue-router'
import Catalog from '../pages/catalog/index.vue'
import Categories from '../pages/categories/index.vue'
import Credits from '../pages/credits/index.vue'
import Home from '../pages/index/index.vue'
import DailyMenu from '../modules/menu/Index.vue'
import Profile from '../pages/profile/index.vue'
import Orders from '../pages/orders/index.vue'
import Feedback from '../pages/feedback/index.vue'
import Information from '../modules/user/UserProfile/userModules/Information.vue'
import Addresses from '../modules/user/UserProfile/userModules/Addresses.vue'
import Favorites from '../modules/user/UserProfile/userModules/Favorites.vue'
import PageLayout from '../layouts/PageLayout.vue'
import Item from '../pages/item/index.vue'
import Cart from '../pages/cart/index.vue'

import itemDetails from '../modules/item/ItemDetails.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: PageLayout,
    children: [{ path: '', name: 'Home', component: Home }],
  },
  {
    path: '/home',
    component: PageLayout,
    children: [{ path: '', name: 'Home', component: Home }],
  },

  {
    path: '/daily-menu',
    name: 'DailyMenu',
    component: DailyMenu,
  },

  {
    path: '/catalog',
    component: PageLayout,
    children: [{ path: '', name: 'Catalog', component: Catalog }],
  },

  {
    path: '/categories',
    component: PageLayout,
    children: [{ path: '', name: 'Categories', component: Categories }],
  },

  {
    path: '/credits',
    component: PageLayout,
    children: [{ path: '', name: 'Credits', component: Credits }],
  },

  {
    path: '/feedback',
    component: PageLayout,
    children: [{ path: '', name: 'Feedback', component: Feedback }],
  },

  {
    path: '/orders',
    component: PageLayout,
    children: [{ path: '', name: 'Orders', component: Orders }],
  },

  {
    path: '/item',
    component: PageLayout,
    children: [{ path: '', name: 'Item', component: Item }],
  },

  {
    path: '/profile',
    component: PageLayout,
    children: [
      {
        path: '',
        name: 'Profile',
        component: Profile,
        children: [
          {
            path: 'information',
            props: true,
            name: 'information',
            component: Information,
          },
          {
            path: 'addresses',
            props: true,
            name: 'addresses',
            component: Addresses,
          },
          {
            path: 'favorites',
            props: true,
            name: 'favorites',
            component: Favorites,
          },
        ],
      },
    ],
  },
  // {
  //   path: '/item',
  //   name: 'Item',
  //   component: Item, //duhet pare
  // },

  {
    path: '/items/:id?',
    component: PageLayout,
    children: [{ path: '', name: 'ItemsDetails', component: itemDetails }],
  },

  {
    path: '/cart',
    component: PageLayout,
    children: [{ path: '', name: 'Cart', component: Cart }],
  },
  // {
  //   path: '/:id?',
  //   name: 'catalog',
  //   component: catalog,
  // },
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
